import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  handleNewTagClick(): void;
  onSendInvitations(): void;
  onExportInviteLinks(): void;
  onExportSelectedInviteLinks(): void;
  selectedInvitationsCount: number;
}

const ManageSurveysTopBar: React.FC<Props> = ({
  handleNewTagClick,
  onSendInvitations,
  onExportInviteLinks,
  onExportSelectedInviteLinks,
  selectedInvitationsCount,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.header}>
      <Typography variant="h5" fontWeight={600}>
        {t('survey')}
      </Typography>
      <Box className={classes.actions}>
        <Button className={classes.button} onClick={handleNewTagClick} variant="contained" startIcon={<AddBoxRoundedIcon />}>
          {t('newSurvey')}
        </Button>
        <Button className={classes.button} onClick={onSendInvitations} variant="outlined" startIcon={<EmailRoundedIcon />}>
          {t('sendInvitations')}
        </Button>
        <Button className={classes.button} onClick={onExportInviteLinks} variant="outlined" startIcon={<FileDownloadRoundedIcon />}>
          {t('exportInviteLinks')}
        </Button>
        <Button
          className={classes.button}
          onClick={onExportSelectedInviteLinks}
          variant="outlined"
          startIcon={<FileDownloadRoundedIcon />}
          disabled={selectedInvitationsCount === 0}
        >
          {t('exportSelectedInviteLinks', { count: selectedInvitationsCount })}
        </Button>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 0),
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(1.5),
  },
  button: {
    textTransform: 'none',
  },
}));

export default ManageSurveysTopBar;
